import { call, put, select } from 'redux-saga/effects';
import { improvementAreaSelectors } from 'store/data/improvementArea';
import { suggestionActions } from 'store/data/suggestion';
import { sagaWrapper } from 'store/helpers';
import { ActionType } from 'typesafe-actions';

import * as improvementsActions from './actions';
import * as constants from './constants';
import * as improvementsSelectors from './selectors';

// Inserts a temporary placeholder suggestion so the user can fill in the form
// before it is persisted. Replaces any existing mock to avoid duplicates.
//
// improvementAreaId resolution:
//   1. If the Suggestions tab's filter dropdown holds a real area id, use it
//      — the dropdown selection doubles as the create default for that tab.
//   2. If it is `null` (All) or the `UNASSIGNED_AREA_ID` sentinel (where the
//      API can't accept the sentinel anyway), fall back to the lowest-
//      sortOrder area — the legacy default behaviour.
export function* startCreateMockSuggestionSaga(
  action: ActionType<typeof improvementsActions.startCreateMockSuggestion>,
) {
  function* saga() {
    const selected: ReturnType<typeof improvementsSelectors.suggestionsAreaId> =
      yield select(improvementsSelectors.suggestionsAreaId);
    const defaultImprovementAreaId: ReturnType<
      typeof improvementAreaSelectors.defaultImprovementAreaId
    > = yield select(improvementAreaSelectors.defaultImprovementAreaId);

    const improvementAreaId =
      selected === null || selected === constants.UNASSIGNED_AREA_ID
        ? defaultImprovementAreaId
        : selected;

    const mockSuggestion: Data.Suggestion = {
      id: constants.MOCKED_SUGGETION_ID,
      improvementAreaId,
      reporter: '',
      name: 'New suggestion',
      problemStatement: '',
      solutionProposal: '',
      status: 'NEW',
      actionIds: [],
      created: new Date().getTime(),
      imageUris: [],
    };

    const hasMockSuggestion: ReturnType<
      typeof improvementsSelectors.hasMockedSuggestion
    > = yield select(improvementsSelectors.hasMockedSuggestion);

    // Remove stale mock before adding the fresh one
    if (hasMockSuggestion) {
      yield put(suggestionActions.remove(mockSuggestion.id));
    }

    yield put(suggestionActions.add(mockSuggestion));
    yield put(improvementsActions.setSelectedSuggestionId(mockSuggestion.id));
  }

  yield call(sagaWrapper, { saga, type: action.type });
}
